export const normalizeEntityBeforeSaving = (group) => {
  const entity = JSON.parse(JSON.stringify(group));
  entity.room = entity.room ? entity.room._id : "";

  if (entity.inventoryType) {
    if (entity.inventoryType.inventoryType) {
      entity.inventoryType = entity.inventoryType.inventoryType;
    }
  } else {
      entity.inventoryType = ''
  }

  if (entity.msoGroup && Object.keys(entity.msoGroup).length === 0) {
    entity.msoGroup = undefined;
  }
  return entity;
};
